module.exports = __webpack_public_path__ + "media/images/fallback-product-d2f148ed.png";